class GnNewsletter extends HTMLElement {
  connectedCallback() {
    this.cleanup();
    const url = new URL(window.location.href);
    if (url.searchParams.has('customer_posted')) {
      url.searchParams.delete('customer_posted');
      history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
    }
    this.onClick = (event) => {
      const reset = event.target.closest('[data-news-reset]');
      if (!reset || !this.contains(reset)) return;
      event.preventDefault();
      window.location.reload();
    };
    this.addEventListener('click', this.onClick);
  }
  cleanup() { this.removeEventListener('click', this.onClick); }
  disconnectedCallback() { this.cleanup(); }
}

if (!customElements.get('gn-newsletter')) customElements.define('gn-newsletter', GnNewsletter);
